export const appRoutes = {
  HEADCOUNT_SCREEN: '/',
  ATTENDANCE_SCREEN: '/attendance',
  PAYROLL_SCREEN: '/payroll-insight',
  PERFORMANCE_REVIEW_SCREEN: '/performance-review',
  EMPLOYEE_AT_RISK: '/employee-at-risk',
  SSO_CALLBACK: '/sso-callback',
  REDIRECT: '/redirect',
  EMPLOYEE_PERFORMANCE_SCREEN: '/employee-performance',
  OVERTIME_SCREEN: '/overtime',
  CUSTOM_DASHBOARD: '/custom-dashboard',
  EXPORT_HISTORY: '/export-history'
};
